import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Tabs, Tab } from 'vue3-tabs-component';
import FactionReigns from '@/components/Faction/FactionReigns.vue';
import { onMounted, ref } from 'vue';
import { useFactionsStore } from '@/store/factions';
import { FactionBrandStatistics } from '@/typings/faction';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useFactionsStore();

const champions = ref<FactionBrandStatistics[]>([]);

onMounted(async () => {
  champions.value = await store.getChampions();
});

return (_ctx: any,_cache: any) => {
  return (champions.value.length)
    ? (_openBlock(), _createBlock(_unref(Tabs), {
        key: 0,
        options: { useUrlFragment: false },
        "nav-class": "flex w-full px-2 mb-2",
        "nav-item-class": "text-sm uppercase hover:text-primary",
        "nav-item-active-class": "border-b-2 border-primary text-primary",
        "nav-item-link-class": "block py-3 mr-3 sm:mr-8"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(champions.value, (brand) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: brand.Brand
            }, [
              (brand.Rankings.length)
                ? (_openBlock(), _createBlock(_unref(Tab), {
                    key: 0,
                    name: brand.Brand
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FactionReigns, {
                        rankings: brand.Rankings
                      }, null, 8, ["rankings"])
                    ]),
                    _: 2
                  }, 1032, ["name"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})